import { Offer } from '@wwt/entities/search-response'
import { showOfferConfigurationOfferStatuses } from '@wwt/shared/config'
import { extractFeaturesFromOffer, groupAllFeatures } from '@wwt/shared/utils'
import { getFullAddress } from '@wwt/shared/utils/address/getFullAddress.ts'

export const useHotelSection = (offer: Offer | null) => {
	const hotelStatic = offer?.hotelStatic
	const hotelDynamic = offer?.hotelDynamic

	const allFeatures = extractFeaturesFromOffer(offer, undefined, {
		room: false,
		hotel: true
	})

	const groupedFeaturesMap = groupAllFeatures(allFeatures)

	const isOfferConfigurationStatuses =
		offer?.IDs.status &&
		showOfferConfigurationOfferStatuses.includes(offer?.IDs.status)

	return {
		name: hotelStatic?.name,
		address: hotelStatic ? getFullAddress(hotelStatic.geolocation.address) : '',
		averageRate: hotelDynamic?.averageRate,
		description: hotelStatic?.description,
		featureGroups: groupedFeaturesMap,
		longitude: hotelStatic?.geolocation.longitude ?? 0,
		latitude: hotelStatic?.geolocation.latitude ?? 0,
		stars: hotelStatic?.stars ?? 0,
		hotelType: hotelStatic?.category ?? '',
		isConfigurationOfferDisabled: !isOfferConfigurationStatuses
	}
}
